export const useFCMStore = defineStore({
  id: "useFCMStore",
  state: () => ({
    fcmToken: null,
    fingerprint: null,
    messages: [],
    userAgent: navigator.userAgent || "",
  }),
  getters: {
    messagesValue: (state) => state.messages,
    fcmTokenValue: (state) => state.fcmToken,
    fingerprintValue: (state) => state.fingerprint,
  },
  actions: {
    async save() {
      const auth = useState("auth");
      const { data } = await RFetch(`/fcm/`, "POST", {
        user_id: auth.value?.id,
        token: this.fcmToken,
        fingerprint: this.fingerprint,
        device: {
          user_agent: this.userAgent,
        },
      });
      if (data) {
        return data;
      }
    },
  },
});
